import getConditionChildrenKey from 'editor/src/store/design/reducer/getConditionChildrenKey';
import { ConditionGroup, conditionGroupChildenKey, Spread } from 'editor/src/store/design/types';
import { getSlotFrameHiddenUuids } from 'editor/src/store/design/util/slotLayout/slotFrameVisibility';

function getConditionLayerIds(
  conditionId: string,
  conditionGroup: ConditionGroup,
  parentIsActive: boolean,
  hiddenIds: Set<number>,
  activeIds: Set<number>,
) {
  const condition = conditionGroup.conditions[conditionId];
  condition.options.forEach((option) => {
    const children = conditionGroup.children[getConditionChildrenKey(conditionId, option.id)] || [];
    const isActive = parentIsActive && condition.activeOptionId === option.id;

    children.forEach((child) => {
      if (child.type === 'condition') {
        getConditionLayerIds(child.id, conditionGroup, isActive, hiddenIds, activeIds);
      } else if (isActive) {
        activeIds.add(child.id);
      } else {
        hiddenIds.add(child.id);
      }
    });
  });

  return { hiddenIds, activeIds };
}

/**
 * Layers the condition tree hides, plus, when the spread is given, the layers of product-layout
 * frames the picked count does not show. The frame rule wins over an active option: a layer is
 * listed under its product's picklist, and its frame decides whether that product is on the page.
 */
function getHiddenMediaElementUuids(
  conditionGroup: ConditionGroup,
  spread?: Pick<Spread, 'slotLayouts' | 'conditionGroup' | 'pages'>,
) {
  const hiddenIds = new Set<number>();
  const activeIds = new Set<number>();

  conditionGroup.children[conditionGroupChildenKey].forEach((child) => {
    if (child.type === 'condition') {
      getConditionLayerIds(child.id, conditionGroup, true, hiddenIds, activeIds);
    } else {
      activeIds.add(child.id);
    }
  });

  activeIds.forEach((id) => hiddenIds.delete(id));
  if (spread) {
    getSlotFrameHiddenUuids(spread).forEach((id) => hiddenIds.add(id));
  }
  return hiddenIds;
}

export default getHiddenMediaElementUuids;
